import { useMemo } from 'react'
import { useVenueDataContext } from '@/VenueDataLoader'

export function useWidgetAppData() {
  const { cookieConsentCustomInclude, googleApiClientId, googlePlacesApiKey, isProd, mediaUrl, stripePublicKey } = useVenueDataContext()
  const appData = useMemo(
    () => ({ cookieConsentCustomInclude, googleApiClientId, googlePlacesApiKey, isProd, mediaUrl, stripePublicKey }),
    [cookieConsentCustomInclude, googleApiClientId, googlePlacesApiKey, isProd, mediaUrl, stripePublicKey]
  )
  return appData
}
